import Footer from '../components/layout/Footer';
import ModuleList from '../components/modules/ModuleList';

export default function Dashboard() {
  return (
    <main className="h-full flex-1 overflow-y-auto overscroll-contain">
      <div className="min-h-full flex flex-col">
        <div className="grow">
          <ModuleList />
        </div>
        <Footer />
      </div>
    </main>
  );
}
